import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getPartnerMasterUrl, GET_PARTNER_MASTER, updatePartnerMasterUrl, UPDATE_PARTNER_MASTER, getPartnerNoteUrl, GET_PARTNER_NOTE, updatePartnerNoteUrl, UPDATE_PARTNER_NOTE } from "../../../../utils/constants";

export const getPartnerMaster_action = (ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getPartnerMasterUrl, params, headers)

        dispatch({
            type: GET_PARTNER_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updatePartnerMaster_action = (ExihibitionID, partnerList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            partnerList: partnerList
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(updatePartnerMasterUrl, params, headers)

        dispatch({
            type: UPDATE_PARTNER_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getPartnerNote_action = (ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID,
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getPartnerNoteUrl, params, headers)

        dispatch({
            type: GET_PARTNER_NOTE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updatePartnerNote_action = (ExihibitionID, partnerListNote) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExihibitionID,
            partnerListNote: partnerListNote
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(updatePartnerNoteUrl, params, headers)

        dispatch({
            type: UPDATE_PARTNER_NOTE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}